

export const leonReviewerReviewHinge = {
  _id: 'leonReviewerReviewHingeId',
  email: 'leon@email.com',
  profileReviewId: 'leonProfileReviewHingeId',
  reviewerProfileId: 'leonReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Leon! This will really help me!',
  profileReviewedFirstName: 'Larry',
}

export const leonReviewerReviewBumble = {
  _id: 'leonReviewerReviewBumbleId',
  email: 'leon@email.com',
  profileReviewId: 'leonProfileReviewBumbleId',
  reviewerProfileId: 'leonReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Leon! This will really help me!',
  profileReviewedFirstName: 'Larry',
}

export const leonReviewerReviewTinder = {
  _id: 'leonReviewerReviewTinderId',
  email: 'leon@email.com',
  profileReviewId: 'leonProfileReviewTinderId',
  reviewerProfileId: 'leonReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Leon! This will really help me!',
  profileReviewedFirstName: 'Larry',
}